import serviceTypeCodes from 'constants/serviceTypeCodes';
import { getMinorsAmount } from 'utils/minors';

export const isEROffer = (outbound = [], inbound = []) =>
  !!outbound?.find((out) => out?.serviceType?.code === serviceTypeCodes.GREENSPEED) ||
  !!inbound?.find((out) => out?.serviceType?.code === serviceTypeCodes.GREENSPEED);

export const getDefaultGroupFormValues = ({ customer, additionalDetails, knownMinors }) => {
  const minorsAmount = getMinorsAmount(additionalDetails);
  const numberOfMinors = minorsAmount ? parseInt(minorsAmount) : knownMinors;

  return {
    groupName: customer?.companyName ?? '',
    email: customer?.email ?? '',
    countryCode: customer?.unformattedPhoneNumber?.countryCode?.replace('+', '') ?? '',
    phoneNumber: customer?.unformattedPhoneNumber?.number ?? '',
    numberOfMinors
  };
};
